export default [
  {
    id: 1,
    label: 'Não enviado',
    value: 'NOT_SENT',
  },
  {
    id: 2,
    label: 'Sucesso',
    value: 'SUCCESS',
  },
  {
    id: 3,
    label: 'Erro',
    value: 'ERROR',
  },
  {
    id: 4,
    label: 'Processando',
    value: 'PROCESSING',
  },
  {
    id: 5,
    label: 'Preparando para processar',
    value: 'TO_BE_PROCESSED',
  },
  {
    id: 6,
    label: 'Aguardando',
    value: 'WAITING_IN_QUEUE',
  },
  {
    id: 7,
    label: 'Em preparação',
    value: 'PREPARING',
  },
  {
    id: 8,
    label: 'Aguardando transportadora',
    value: 'WAITING_LOGISTIC_PROVIDER',
  },
  {
    id: 9,
    label: 'Pré lista de postagem agendada',
    value: 'SCHEDULED',
  },
  {
    id: 10,
    label: 'Erro na transportadora',
    value: 'UNAVAILABLE_LOGISTIC_PROVIDER',
  },
];



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-psl/features/list/enums/localizedStatusFilter.enum.js